export default {"src":"/_next/static/media/0xd6df932a45c0f255f85145f286ea0b292b21c90b.94d275b4.svg","height":126,"width":126,"blurWidth":0,"blurHeight":0};